export default {
    template: '#layers_control',
    props: ['currentSide'],
    data: function () {
        return {
            currentDesignerItems: []
        }
    },
    ready: function () {
        var that = this;
        $(".accordion").accordion({
            heightStyle: "content",
            collapsible: true
        });

        //Setting up the Layers Sortable functionality
        $("#layers").sortable({
            stop: function () {
                that.sortLayers();
            }
        });
    },
    methods: {
        sortLayers: function () {
            var totalSortableIndex = $('#layers .layer').length,
                designItems = this.currentDesignerItems;

            //Adding 10 to it, because when initializing the indexes it started from 11
            totalSortableIndex = totalSortableIndex + 10;
            $('#layers .layer').each(function () {
                var id = $(this).data('id').replace('layer-', '');

                var foundItem = _.find(designItems, function (item) {
                    return item.id == id;
                });

                foundItem.span.index = totalSortableIndex;
                totalSortableIndex--;
            });
        },
        selectItem: function (designerItem) {
            this.$root.unSelectAllControls();
            this.$root.$set('selectedItem', designerItem);
            this.$root.selectItem();
        },
        removeItem: function (designerItem) {
            this.$dispatch('item-removed', designerItem.id);
        },
        isSelected: function (item) {
            if (this.$root.selectedItem)
                if (this.$root.selectedItem.hasOwnProperty('id'))
                    return this.$root.selectedItem.id == item.id;
        }
    },
    computed: {
        currentDesignerItems: function () {
            var items = (this.currentSide == 'front' ? this.$root.designerItems.front : this.$root.designerItems.back);
            if (items.length > 0) {
                return _.sortByOrder(items, function (item) {
                    return item.span.index;
                }, ['desc']);
            } else {
                return [];
            }
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/layersControl.js